import { useEffect, useState, useContext } from 'react';
import { NotificationsContext } from '../providers/NotificationsProvider';
import { OutageMapNotificationContext } from '../providers/OutageMapNotificationProvider';
import { useIsMobile } from '../util/style-utils';

export default () => {
  const [bannerVisiblity, setBannerVisiblity] = useState<boolean>(false);
  const broadcastMessageContainerHeight =
    typeof document !== 'undefined'
      ? document.getElementById('global-messages-container')?.offsetHeight
      : 0;
  const [
    globalMessagesContainerHeight,
    setGlobalMessagesContainerHeight,
  ] = useState<number>(
    broadcastMessageContainerHeight == undefined
      ? 0
      : broadcastMessageContainerHeight,
  );
  const isMobile = useIsMobile();

  const [outageBannerVisibility, setOutageBannerVisibility] = useState<boolean>(
    false,
  );
  const [pgeHeaderHeight, setPgeHeaderHeight] = useState(0);

  const [
    notificationContainerHeight,
    setNotificationContainerHeight,
  ] = useState<number>(0);

  const [
    outageGlobalMessagesContainerHeight,
    setOutageGlobalMessagesContainerHeight,
  ] = useState<number>(0);

  const [
    outageNotificationContainerHeight,
    setOutageNotificationContainerHeight,
  ] = useState<number>(
    isMobile
      ? 20
      : broadcastMessageContainerHeight == undefined
      ? 0
      : broadcastMessageContainerHeight,
  );

  const notificationContext = useContext(NotificationsContext);
  const outageMapNotificationContext = useContext(OutageMapNotificationContext);

  useEffect(() => {
    const pgeHeaderElement = document.getElementById(
      'pge-header',
    ) as HTMLElement;
    setPgeHeaderHeight(pgeHeaderElement?.offsetHeight || 0);
  });

  useEffect(() => {
    const notificationMessageContainer: HTMLElement = document.getElementById(
      'global-notifications-banner',
    ) as HTMLElement;
    setTimeout(() => {
      if (notificationMessageContainer) {
        setNotificationContainerHeight(
          notificationMessageContainer.offsetHeight > 10
            ? notificationMessageContainer.offsetHeight
            : 0,
        );
      }
    }, 300);
  }, [notificationContext?.state?.isOpen]);

  useEffect(() => {
    const outageNotificationMessageContainer: HTMLElement = document.getElementById(
      'outage-notification-messages-container',
    ) as HTMLElement;
    setTimeout(() => {
      if (outageNotificationMessageContainer) {
        setOutageNotificationContainerHeight(
          outageNotificationMessageContainer.offsetHeight > 10
            ? outageNotificationMessageContainer.offsetHeight
            : isMobile
            ? 20
            : 0,
        );
      }
    }, 300);
  }, [outageMapNotificationContext?.state?.isOpen]);

  useEffect(() => {
    //Increase top position of the panel if the broadcast message is available
    const broadcastMessageContainer: HTMLElement = document.getElementById(
      'global-messages-container',
    ) as HTMLElement;

    const outageGlobalMessagesContainer: HTMLElement = document.getElementById(
      'outage-global-messages-container',
    ) as HTMLElement;

    broadcastMessageContainer?.querySelectorAll('button').forEach(button =>
      button.addEventListener('click', () => {
        setTimeout(() => {
          if (broadcastMessageContainer) {
            setGlobalMessagesContainerHeight(
              broadcastMessageContainer.offsetHeight > 10
                ? broadcastMessageContainer.offsetHeight
                : 0,
            );
          }
        }, 300);
      }),
    );

    outageGlobalMessagesContainer?.querySelectorAll('button').forEach(button =>
      button.addEventListener('click', () => {
        setTimeout(() => {
          if (outageGlobalMessagesContainer) {
            setOutageGlobalMessagesContainerHeight(
              outageGlobalMessagesContainer.offsetHeight > 10
                ? outageGlobalMessagesContainer.offsetHeight
                : 0,
            );
          }
        }, 300);
      }),
    );
  }, []);

  useEffect(() => {
    //Settimeout is used here to calculate the height after the slide down transition is completed
    setTimeout(() => {
      const globalMessagesContainer: HTMLElement = document.getElementById(
        'global-messages-container',
      ) as HTMLElement;
      if (globalMessagesContainer) {
        setGlobalMessagesContainerHeight(
          globalMessagesContainer.offsetHeight > 10
            ? globalMessagesContainer.offsetHeight
            : 0,
        );
      }
    }, 300);
  }, [bannerVisiblity]); // bannerVisiblity not used?

  useEffect(() => {
    setTimeout(() => {
      const outageGlobalMessagesContainer: HTMLElement = document.getElementById(
        'outage-global-messages-container',
      ) as HTMLElement;

      if (outageGlobalMessagesContainer) {
        setOutageGlobalMessagesContainerHeight(
          outageGlobalMessagesContainer.offsetHeight > 10
            ? outageGlobalMessagesContainer.offsetHeight
            : 0,
        );
      }
    }, 300);
  }, [outageBannerVisibility]);

  return {
    globalContainerHeight: globalMessagesContainerHeight,
    pgeHeaderHeight,
    outageGlobalMessagesContainerHeight,
    notificationVisiblity: notificationContext?.state?.isOpen,
    notificationContainerHeight,
    outageMapNotificationVisibility:
      outageMapNotificationContext?.state?.isOpen,
    outageNotificationContainerHeight: outageNotificationContainerHeight,
  };
};
